import './overallSummary.css';
const OverallSummary = ({data}) => {
    const summaryObj = [
        {
            data: <span><span className={'green-color'}>19k</span>/21k</span>,
            title: <span>Improved alertness <br/> compared to last week</span>
        },
        {
            data: <span><span className={'green-color'}>16k</span>/18k</span>,
            title: <span>23% less <br/> Collision warnings</span>
        },
        {
            data: <span><span className={'green-color'}>2k</span>/1.2k</span>,
            title: <span>Improved productivity <br/> compared to last week</span>
        },
        {
            data: <span><span className={'green-color'}>12k</span>/10k</span>,
            title: <span>19% less <br/> Overall violations</span>
        },
        {
            data: <span><span className={'red-color'}>2k</span>/1.5k</span>,
            title: <span>Rash driving increased <br/> from last week</span>
        }
    ];
    const summaryContent = data ?? summaryObj;

    return(
        <ul className={'overall-summary grid col-5 gap-0'}>
            {summaryContent.map((summary, index) =>
                <li key={index} className="">
                    <div className="number light-color sf-bold">{summary.data}</div>
                    <div className="title sf-medium">{summary.title}</div>
                </li>
            )}
            {/*<li className="">*/}
            {/*    /!*<div className="name sf-medium">Distractions</div>*!/*/}
            {/*    <div className="number light-color sf-bold"><span className={'green-color'}>19k</span>/21k</div>*/}
            {/*    <div className="title sf-medium">Improved alertness <br/> compared to last week</div>*/}
            {/*</li>*/}
            {/*<li className="">*/}
            {/*    /!*<div className="name sf-medium">Stress</div>*!/*/}
            {/*    <div className="number light-color sf-bold"><span className={'green-color'}>16k</span>/18k</div>*/}
            {/*    <div className="title sf-medium">23% less <br/> Collision warnings</div>*/}
            {/*</li>*/}
            {/*<li className="">*/}
            {/*    /!*<div className="name sf-medium">Drowsy</div>*!/*/}
            {/*    <div className="number light-color sf-bold"><span className={'green-color'}>2k</span>/1.2k</div>*/}
            {/*    <div className="title sf-medium">Improved productivity <br/> compared to last week</div>*/}
            {/*</li>*/}
            {/*<li className="">*/}
            {/*    /!*<div className="name sf-medium">HMW/FCW</div>*!/*/}
            {/*    <div className="number light-color sf-bold"><span className={'green-color'}>12k</span>/10k</div>*/}
            {/*    <div className="title sf-medium">19% less <br/> Overall violations</div>*/}
            {/*</li>*/}
            {/*<li className="">*/}
            {/*    /!*<div className="name sf-medium">HC/HB</div>*!/*/}
            {/*    <div className="number light-color sf-bold"><span className={'red-color'}>2k</span>/1.5k</div>*/}
            {/*    <div className="title sf-medium">Rash driving increased <br/> from last week</div>*/}
            {/*</li>*/}
        </ul>
    )
}

export default OverallSummary;
